const BASE_PATH_AGENDA = "/agenda/zoeken";
const BASE_PATH_ARCHIEF = "/agenda/archief";

export { BASE_PATH_AGENDA, BASE_PATH_ARCHIEF };
